import { execute } from "./_api";

const BASE_URL_NOTIFICACOES = "notificacoes";

export const contar = (data, params = {}) => {

    let rota = BASE_URL_NOTIFICACOES + "/contar";

    execute(rota,"GET",data, params);
}

export const listarNaoLidas = (data, params = {}) => {

    let rota = BASE_URL_NOTIFICACOES + "/listarNaoLidas";

    execute(rota,"GET",data, params);
}

export const marcarComoLida = (data, params = {}) => {

    let rota = BASE_URL_NOTIFICACOES + "/marcarComoLida";

    execute(rota,"POST",data, params);
}

